import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import moment from "moment";
import feederListActions from "../../_actions/feederListActions";
import LaborWeeklyInputs from "./LaborWeeklyInputs";
import ContractorWeeklyInputs from "./ContractorWeeklyInputs";
import WorkPerformedInputs from "./WorkPerformedInputs";
import ItemEstimateQuantitiesInputs from "./ItemEstimateQuantitiesInputs";
import CommentKeywordInputs from "./CommentKeywordInputs";
import ProjSelector from "../_common/ProjSelector";
import { DOCTYPE } from "../../_constants/docTypeConstants";
import { projSelectorConstants } from "../../_constants/projSelectorConstants";
import { isNullOrZero } from "../../_utils/generalUtils";
import { actionScripts } from "../../_helpers/actionScripts";
import QUERYTYPES from "../../_constants/queryTypes";
import QUERYOPERATOR from "../../_constants/queryOperators";

class ReportSelection extends Component {
  state = {
    projectId: 0,
    selectedReportType: null,
    lw_weekOf: new Date(),
    lw_contractorId: 0,
    lw_selectedContractor: null,
    lw_laborIds: [],
    lw_selectedLabors: [],
    workPerformed: {
      dateQueryType: "allDates",
      singleDate: new Date(),
      dateFrom: new Date(),
      dateTo: new Date(),
      parentOperator: QUERYOPERATOR.OR,
      criteria: [
        {
          criteriaId: 0,
          queryBy: QUERYTYPES.ITEM,
          queryByLabel: "Items",
          selectedQueryBy: null,
          childOperator: QUERYOPERATOR.OR,
          params: [],
          selectedParams: [],
        },
        {
          criteriaId: 1,
          queryBy: QUERYTYPES.CCO,
          queryByLabel: "Change Orders",
          selectedQueryBy: null,
          childOperator: QUERYOPERATOR.OR,
          params: [],
          selectedParams: [],
        },
        {
          criteriaId: 2,
          queryBy: QUERYTYPES.PENDINGISSUE,
          queryByLabel: "Pending Issues",
          selectedQueryBy: null,
          childOperator: QUERYOPERATOR.OR,
          params: [],
          selectedParams: [],
        },
        {
          criteriaId: 3,
          queryBy: QUERYTYPES.LABOR,
          queryByLabel: "Labors",
          selectedQueryBy: null,
          childOperator: QUERYOPERATOR.OR,
          params: [],
          selectedParams: [],
        },
        {
          criteriaId: 4,
          queryBy: QUERYTYPES.EQUIPMENT,
          queryByLabel: "Equipment",
          selectedQueryBy: null,
          childOperator: QUERYOPERATOR.OR,
          params: [],
          selectedParams: [],
        },
        {
          criteriaId: 5,
          queryBy: QUERYTYPES.CONTRACTOR,
          queryByLabel: "Contractors",
          selectedQueryBy: null,
          childOperator: QUERYOPERATOR.OR,
          params: [],
          selectedParams: [],
        },
      ],
    },
    cw_weekOf: new Date(),
    cw_contractorId: 0,
    cw_selectedContractor: null,
    ieq_dateSearchType: "allDates",
    ieq_dateFrom: new Date(),
    ieq_dateTo: new Date(),
    ieq_itemIds: null,
    ieq_selectedItems: null,
    ck_dateSearchType: "allDates",
    ck_dateFrom: new Date(),
    ck_dateTo: new Date(),
    ck_keywordId: 0,
    ck_selectedKeyword: null,
    formErrors: {
      ieq_selectedItems: null,
      ck_selectedKeyword: null,
    },
    ieq_selectedItemsSearchType: "allItems",
  };

  reportTypeOptions = [
    //{
    //  value: DOCTYPE.REPORT_PAYMENT_STATUS,
    //  label: "Payment Status",
    //  isDisabled: true,
    //},
    //{ value: DOCTYPE.REPORT_CCO, label: "CCO Status", isDisabled: true },
    //{ value: DOCTYPE.REPORT_WSWD, label: "WSWD", isDisabled: true },
    {
      value: DOCTYPE.REPORT_ITEM_EST_QUANTITIES,
      label: "Est. Reported Item Quantities",
    },
    { value: DOCTYPE.REPORT_COMMENT_KEYWORD, label: "Comments by Keyword" },
    {
      value: DOCTYPE.REPORT_CONTRACTOR_WEEKLY,
      label: "Weekly Contractor",
    },
    {
      value: DOCTYPE.REPORT_LABOR_WEEKLY,
      label: "Weekly Labor",
    },
    {
      value: DOCTYPE.REPORT_WORK_PERFORMED,
      label: "Labor and Equipment Hours",
    },
    //{
    //  value: DOCTYPE.REPORT_OVERTIME,
    //  label: "Overtime",
    //  isDisabled: true,
    //},
  ];

  isSaturday = (date) => {
    const day = moment(date).day();
    return day === 6;
  };

  /////////////////////////////////////////////////////////////////////////////
  /// Form Handlers - Labor Weekly Report
  /////////////////////////////////////////////////////////////////////////////
  handleChange_lw_weekOf = (value) => this.setState({ lw_weekOf: value });
  handleChange_lw_contractor = (lw_selectedContractor) =>
    this.setState({
      lw_contractorId: lw_selectedContractor.value,
      lw_selectedContractor,
    });
  handleChange_lw_labors = (lw_selectedLabors) =>
    this.setState({
      lw_laborIds: lw_selectedLabors.map((l) => l.value),
      lw_selectedLabors,
    });

  /////////////////////////////////////////////////////////////////////////////
  /// Form Handlers - Labor and Equipment
  /////////////////////////////////////////////////////////////////////////////
  handleChange_wp_dateQueryType = (e) =>
    this.setState({
      workPerformed: {
        ...this.state.workPerformed,
        dateQueryType: e.target.name,
      },
    });

  handleChange_wp_singleDate = (singleDate) =>
    this.setState({
      workPerformed: { ...this.state.workPerformed, singleDate },
    });

  handleChange_wp_dateFrom = (dateFrom) =>
    this.setState({ workPerformed: { ...this.state.workPerformed, dateFrom } });

  handleChange_wp_dateTo = (dateTo) =>
    this.setState({ workPerformed: { ...this.state.workPerformed, dateTo } });

  handleChange_wp_select =
    (criteriaId, fieldName, optionFieldName) => (selectedOption) => {
      const criteria = this.state.workPerformed.criteria.map((wpt) => ({
        ...wpt,
      }));
      const selCriterion = criteria.find((wpt) => wpt.criteriaId === criteriaId);
      if (selCriterion) {
        selCriterion[fieldName] = selectedOption.value;
        selCriterion[optionFieldName] = selectedOption;
        const workPerformed = { ...this.state.workPerformed, criteria };
        this.setState({ workPerformed });
      }
    };

  handleChange_wp_selectMulti = (criteriaId) => (selectedOptions) => {
    const criteria = this.state.workPerformed.criteria.map((wpt) => ({
      ...wpt,
    }));
    const selCriterion = criteria.find((wpt) => wpt.criteriaId === criteriaId);
    if (selCriterion) {
      selCriterion.params = selectedOptions ? selectedOptions.map((o) => o.value) : [];
      selCriterion.selectedParams = selectedOptions;
      const workPerformed = { ...this.state.workPerformed, criteria };
      this.setState({ workPerformed });
    }
  };

  handleClick_wp_parentOperator = (queryOp) => (e) => {
    e.preventDefault();
    const wp = { ...this.state.workPerformed };
    wp.parentOperator =
      queryOp === QUERYOPERATOR.AND ? QUERYOPERATOR.AND : QUERYOPERATOR.OR;
    this.setState({ workPerformed: wp });
  };

  handleClick_wp_and = (criteriaId) => (e) => {
    e.preventDefault();
    const criteria = this.state.workPerformed.criteria.map((wpt) => ({
      ...wpt,
    }));
    const selCriterion = criteria.find((wpt) => wpt.criteriaId === criteriaId);
    if (selCriterion) {
      selCriterion.childOperator = QUERYOPERATOR.AND;
      const workPerformed = { ...this.state.workPerformed, criteria };
      this.setState({ workPerformed });
    }
  };

  handleClick_wp_or = (criteriaId) => (e) => {
    e.preventDefault();
    const criteria = this.state.workPerformed.criteria.map((wpt) => ({
      ...wpt,
    }));
    const selCriterion = criteria.find((wpt) => wpt.criteriaId === criteriaId);
    if (selCriterion) {
      selCriterion.childOperator = QUERYOPERATOR.OR;
      const workPerformed = { ...this.state.workPerformed, criteria };
      this.setState({ workPerformed });
    }
  };

  /////////////////////////////////////////////////////////////////////////////
  /// Form Handlers - Contractor Weekly Report
  /////////////////////////////////////////////////////////////////////////////
  handleChange_cw_weekOf = (value) => this.setState({ cw_weekOf: value });
  handleChange_cw_contractor = (cw_selectedContractor) =>
    this.setState({
      cw_contractorId: cw_selectedContractor.value,
      cw_selectedContractor,
    });

  /////////////////////////////////////////////////////////////////////////////
  /// Form Handlers - Item Est. Qty Report
  /////////////////////////////////////////////////////////////////////////////
  handleChange_ieq_dateSearchType = (e) =>
    this.setState({
      ieq_dateSearchType: e.target.name,
    });
  handleChange_ieq_dateFrom = (value) => this.setState({ ieq_dateFrom: value });
  handleChange_ieq_dateTo = (value) => this.setState({ ieq_dateTo: value });
  handleChange_ieq_item = (ieq_selectedItems, context) => {
    this.setState({
      ieq_selectedItems,
    });
  };
  handleChange_ieq_selectedItemsSearchType = (e) =>
    this.setState({
      ieq_selectedItemsSearchType: e.target.name,
    });

  /////////////////////////////////////////////////////////////////////////////
  /// Form Handlers - Comment Keyword Report
  /////////////////////////////////////////////////////////////////////////////
  handleChange_ck_dateSearchType = (e) =>
    this.setState({
      ck_dateSearchType: e.target.name,
    });
  handleChange_ck_keyword = (ck_selectedKeyword) =>
    this.setState({
      ck_keywordId: ck_selectedKeyword.value,
      ck_selectedKeyword,
    });
  handleChange_ck_dateFrom = (value) => this.setState({ ck_dateFrom: value });
  handleChange_ck_dateTo = (value) => this.setState({ ck_dateTo: value });

  /////////////////////////////////////////////////////////////////////////////
  /// Form Handlers - Main Form
  /////////////////////////////////////////////////////////////////////////////
  onProjectSelect = (projectId) => {
    this.setState({ projectId });
    const { dispatch } = this.props;
    if (!isNullOrZero(projectId)) {
      dispatch(feederListActions.getAll(projectId));
      dispatch(feederListActions.getAllStatic());
    }
  };

  handleChange_reportSelection = (selectedReportType) =>
    this.setState({ selectedReportType });

  handleSubmit_reportSelection = (e) => {
    e.preventDefault();
    this.validateForm();

    const { user } = this.props;
    const {
      projectId,
      selectedReportType,
      lw_weekOf,
      lw_contractorId,
      lw_laborIds,
      workPerformed,
      cw_weekOf,
      cw_contractorId,
      ieq_dateSearchType,
      ieq_selectedItems,
      ieq_dateFrom,
      ieq_dateTo,
      ck_dateSearchType,
      ck_dateFrom,
      ck_dateTo,
      ck_keywordId,
      ieq_selectedItemsSearchType,
    } = this.state;

    if (!this.formIsIncomplete()) {
      let searchAllDates = false;
      let reportParams = {
        projectId,
        reportId: 0,
        createdBy: user.fullName,
        reportType: selectedReportType.value,
      };

      switch (selectedReportType.value) {
        case DOCTYPE.REPORT_LABOR_WEEKLY:
          reportParams = {
            ...reportParams,
            label: "Labor Weekly Report",
            weekEnding: moment(lw_weekOf).format("YYYY-MM-DD"),
            contractorId: lw_contractorId,
            laborIds: lw_laborIds ? lw_laborIds.map((l) => parseInt(l, 10)) : [],
          };
          break;
        case DOCTYPE.REPORT_CONTRACTOR_WEEKLY:
          reportParams = {
            ...reportParams,
            label: "Contractor Weekly Report",
            weekEnding: moment(cw_weekOf).format("YYYY-MM-DD"),
            contractorId: cw_contractorId,
          };
          break;
        case DOCTYPE.REPORT_ITEM_EST_QUANTITIES:
          searchAllDates = ieq_dateSearchType === "allDates" ? true : false;
          reportParams = {
            ...reportParams,
            label: "Item Estimated Quantities",
            selectedItemIds: ieq_selectedItems
              ? ieq_selectedItems.map((i) => i.value)
              : [],
            searchAllDates,
            dateFrom: moment(ieq_dateFrom).format(),
            dateTo: moment(ieq_dateTo).format(),
          };
          break;
        case DOCTYPE.REPORT_COMMENT_KEYWORD:
          searchAllDates = ck_dateSearchType === "allDates" ? true : false;
          reportParams = {
            ...reportParams,
            label: "Comments by Keyword Report",
            keywordId: ck_keywordId,
            searchAllDates,
            dateFrom: moment(ck_dateFrom).format(),
            dateTo: moment(ck_dateTo).format(),
          };
          break;
        case DOCTYPE.REPORT_WORK_PERFORMED:
          reportParams = {
            ...reportParams,
            label: "Labor and Equipment Hours",
            dateQueryType: workPerformed.dateQueryType,
            dateFrom:
              workPerformed.dateQueryType === "singleDate"
                ? workPerformed.singleDate
                : workPerformed.dateFrom,
            dateTo: workPerformed.dateTo,
            parentOperator: workPerformed.parentOperator,
            criteria: workPerformed.criteria || [],
          };
          break;
        default:
          break;
      }

      actionScripts.CREATE_REPORT.run(reportParams);
      //this.resetState();
    }
  };

  resetProjectId = () => this.setState({ projectId: 0 });

  /* No longer need to reset state since this component is now a tab and not a modal
  resetState = () => {
    this.setState({
      //projectId: 0,
      selectedReportType: null,
      lw_weekOf: new Date(),
      lw_contractorId: 0,
      lw_selectedContractor: null,
      lw_laborIds: [],
      lw_selectedLabors: [],
      cw_weekOf: new Date(),
      cw_contractorId: 0,
      cw_selectedContractor: null,
      ieq_itemIds: null,
      ieq_selectedItems: null,
      ieq_dateFrom: new Date(),
      ieq_dateTo: new Date(),
      ck_dateSearchType: "allDates",
      ck_keywordId: 0,
      ck_selectedKeyword: null,
      ck_dateFrom: new Date(),
      ck_dateTo: new Date(),
    });
  };
  */
  validateForm = () => {
    const { selectedReportType, ieq_selectedItems, ck_selectedKeyword } = this.state;
    const formErrors = { ...this.state.formErrors };
    switch (selectedReportType.value) {
      case DOCTYPE.REPORT_COMMENT_KEYWORD:
        if (ck_selectedKeyword === null) formErrors.ck_selectedKeyword = "Required";
        else formErrors.ck_selectedKeyword = null;
        break;
      default:
        break;
    }
    this.setState({ formErrors });
  };

  formIsIncomplete = () => {
    const { selectedReportType, ck_selectedKeyword } = this.state;
    if (selectedReportType)
      switch (selectedReportType.value) {
        case DOCTYPE.REPORT_COMMENT_KEYWORD:
          return ck_selectedKeyword === null ? true : false;
        default:
          return false;
      }
    return true;
  };

  renderReportInputForm = () => {
    const { selectedReportType, projectId } = this.state;
    const {
      fetching,
      projContractorLists,
      projLaborLists,
      projEquipLists,
      projItemLists,
      projCcoLists,
      projPendingIssueLists,
      projKeywordLists,
    } = this.props;

    switch (selectedReportType && selectedReportType.value) {
      case DOCTYPE.REPORT_LABOR_WEEKLY: {
        const { lw_weekOf, lw_selectedContractor, lw_selectedLabors } = this.state;
        return (
          <LaborWeeklyInputs
            projLaborList={projLaborLists[projectId] || []}
            projContractorList={projContractorLists[projectId] || []}
            lw_weekOf={lw_weekOf}
            handleChange_lw_weekOf={this.handleChange_lw_weekOf}
            isSaturday={this.isSaturday}
            lw_selectedContractor={lw_selectedContractor}
            lw_selectedLabors={lw_selectedLabors}
            handleChange_lw_contractor={this.handleChange_lw_contractor}
            handleChange_lw_labors={this.handleChange_lw_labors}
            disabled={projectId === 0 || fetching}
          />
        );
      }
      case DOCTYPE.REPORT_CONTRACTOR_WEEKLY: {
        const { cw_weekOf, cw_selectedContractor } = this.state;
        return (
          <ContractorWeeklyInputs
            projContractorList={projContractorLists[projectId] || []}
            cw_weekOf={cw_weekOf}
            handleChange_cw_weekOf={this.handleChange_cw_weekOf}
            isSaturday={this.isSaturday}
            cw_selectedContractor={cw_selectedContractor}
            handleChange_cw_contractor={this.handleChange_cw_contractor}
            disabled={projectId === 0 || fetching}
          />
        );
      }
      case DOCTYPE.REPORT_WORK_PERFORMED: {
        const { workPerformed } = this.state;
        const wpParamSelectData = (criteriaId) => {
          const selCriteria = this.state.workPerformed.criteria.find(
            (wpt) => wpt.criteriaId === criteriaId
          );
          if (selCriteria) {
            switch (selCriteria.queryBy) {
              case QUERYTYPES.ITEM:
                return {
                  options: (projItemLists[projectId] || []).map((i) => ({
                    value: i.bidItemId,
                    label: i.itemListCaption,
                  })),
                  placeholder: "Select Item(s)",
                };
              case QUERYTYPES.CCO:
                return {
                  options: (projCcoLists[projectId] || []).map((c) => ({
                    value: c.ccoId,
                    label: c.ccoListCaption,
                  })),
                  placeholder: "Select CCO(s)",
                };
              case QUERYTYPES.PENDINGISSUE:
                return {
                  options: (projPendingIssueLists[projectId] || []).map((pi) => ({
                    value: pi.pendingIssueId,
                    label: pi.pendingIssueListCaption,
                  })),
                  placeholder: "Select Pending Issue(s)",
                };
              case QUERYTYPES.CONTRACTOR:
                return {
                  options: (projContractorLists[projectId] || []).map((c) => ({
                    value: c.contractorId,
                    label: c.name,
                  })),
                  placeholder: "Select Contractor(s)",
                };
              case QUERYTYPES.LABOR:
                return {
                  options: (projLaborLists[projectId] || []).map((l) => ({
                    value: l.laborId,
                    label: l.fullName,
                  })),
                  placeholder: "Select Labor(s)",
                };
              case QUERYTYPES.EQUIPMENT:
                return {
                  options: (projEquipLists[projectId] || []).map((eq) => ({
                    value: eq.equipmentId,
                    label: eq.numberMakeDesc,
                  })),
                  placeholder: "Select Equipment",
                };
              default:
                return {
                  options: [],
                  placeholder: " ",
                };
            }
          }
        };
        return (
          <WorkPerformedInputs
            projectId={projectId}
            formData={workPerformed}
            handleChange_dateQueryType={this.handleChange_wp_dateQueryType}
            handleChange_singleDate={this.handleChange_wp_singleDate}
            handleChange_dateFrom={this.handleChange_wp_dateFrom}
            handleChange_dateTo={this.handleChange_wp_dateTo}
            handleClick_parentOperator={this.handleClick_wp_parentOperator}
            handleChange_selectMulti={this.handleChange_wp_selectMulti}
            handleClick_and={this.handleClick_wp_and}
            handleClick_or={this.handleClick_wp_or}
            wpParamSelectData={wpParamSelectData}
            handleChange_wp_itemSearchType={this.handleChange_wp_itemSearchType}
            disabled={projectId === 0 || fetching}
          />
        );
      }
      case DOCTYPE.REPORT_ITEM_EST_QUANTITIES: {
        const {
          ieq_dateSearchType,
          ieq_dateFrom,
          ieq_dateTo,
          ieq_selectedItems,
          ieq_selectedItemsSearchType,
        } = this.state;
        return (
          <ItemEstimateQuantitiesInputs
            projItemList={projItemLists[projectId] || []}
            ieq_dateSearchType={ieq_dateSearchType}
            ieq_dateFrom={ieq_dateFrom}
            ieq_dateTo={ieq_dateTo}
            ieq_selectedItems={ieq_selectedItems}
            handleChange_ieq_dateSearchType={this.handleChange_ieq_dateSearchType}
            handleChange_ieq_dateFrom={this.handleChange_ieq_dateFrom}
            handleChange_ieq_dateTo={this.handleChange_ieq_dateTo}
            handleChange_ieq_item={this.handleChange_ieq_item}
            disabled={projectId === 0 || fetching}
            ieq_selectedItemsSearchType={ieq_selectedItemsSearchType}
            handleChange_ieq_selectedItemsSearchType={
              this.handleChange_ieq_selectedItemsSearchType
            }
          />
        );
      }
      case DOCTYPE.REPORT_COMMENT_KEYWORD: {
        const { ck_dateSearchType, ck_dateFrom, ck_dateTo, ck_selectedKeyword } =
          this.state;
        return (
          <CommentKeywordInputs
            projKeywordList={projKeywordLists[projectId] || []}
            ck_dateSearchType={ck_dateSearchType}
            ck_dateFrom={ck_dateFrom}
            ck_dateTo={ck_dateTo}
            ck_selectedKeyword={ck_selectedKeyword}
            handleChange_ck_dateSearchType={this.handleChange_ck_dateSearchType}
            handleChange_ck_dateFrom={this.handleChange_ck_dateFrom}
            handleChange_ck_dateTo={this.handleChange_ck_dateTo}
            handleChange_ck_keyword={this.handleChange_ck_keyword}
            disabled={projectId === 0 || fetching}
          />
        );
      }
      default:
        break;
    }
  };

  render() {
    const { user } = this.props;
    const { selectedReportType, projectId } = this.state;
    
    return (
      <div className="container-fluid mt-3">
        <div className="card">
          <div className="card-header bg-lightgray">
            <h5 className="mb-0">Generate Reports</h5>
          </div>
          <div className="card-body">
            <form id="reportSelectionForm" onSubmit={this.handleSubmit_reportSelection}>
              <ProjSelector
                tabId={this.props.tab.tabId}
                showProjectsFor={{
                  type: projSelectorConstants.USER_ASSIGNED,
                  lookupId: user.userId,
                }}
                onProjectSelect={this.onProjectSelect}
                resetProjectId={this.resetProjectId}
              />
              <div className="card m-2">
                <div className="card-body pb-0">
                  <div className="form-row form-group">
                    <label className="col-sm-3 col-form-label">
                      <strong>Report Type:</strong>
                    </label>
                    <div className="col-sm-9">
                      <Select
                        name="reportSelection"
                        id="reportSelection"
                        value={selectedReportType}
                        options={this.reportTypeOptions}
                        onChange={this.handleChange_reportSelection}
                        isSearchable={false}
                      />
                    </div>
                  </div>
                  {this.renderReportInputForm()}
                </div>
              </div>
              <div className="form-row form-group mt-3">
                <div className="col-12">
                  <small className="text-muted mr-3">
                    Report will open in a new tab.
                  </small>
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={projectId === 0 || this.formIsIncomplete()}
                  >
                    Generate Report
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.authentication.user,
  projItemLists: state.bidItems.projItemLists,
  projCcoLists: state.ccos.projCcoLists,
  projPendingIssueLists: state.pendingIssues.projPendingIssueLists,
  projContractorLists: state.contractors.projContractorLists,
  projLaborLists: state.labors.projLaborLists,
  projEquipLists: state.equipment.projEquipLists,
  projKeywordLists: state.keywords.projKeywordLists,
});

export default connect(mapStateToProps)(ReportSelection);
